import {
  Component,
  computed,
  EventEmitter,
  input,
  Output,
  signal,
  WritableSignal,
} from '@angular/core';
import { WorkOrderActionsGRPCService } from '../../../ProxyServices/workorderactions.grpc.service';
import { map, shareReplay } from 'rxjs/operators';
import { Observable, timer } from 'rxjs';
import {
  DispatchRequestModel,
  DispatchValidationHitGroupModel,
  FSRWOCountRequestModel,
  TechModel,
  TerritoryModel,
  UserWOCountModel,
  ViewResponseModel,
  WorkOrderBase,
} from '../../../CommonFiles/BusinessModels';
import { TerritoryUser } from '../../../proto/generated/Territory_message_pb';
import { WOStatusWeb } from '../../../constants/woStatusOptions';
import { GridBaseComponent } from '../../../OFramework/Grid/GridBaseComponent';
import { State, filterBy } from '@progress/kendo-data-query';
import { WorkorderGRPCService } from '../../../ProxyServices/workorder.grpc.service';
import { faCheck, faTimes, faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons';
import {
  faUserPlus,
  faCircleArrowLeft,
} from '@fortawesome/pro-regular-svg-icons';

@Component({
  standalone: false,
  selector: 'app-dispatch-recall',
  templateUrl: './dispatch-recall.component.html',
  styleUrls: ['./dispatch-recall.component.scss'],
})
export class DispatchRecallComponent extends GridBaseComponent<UserWOCountModel> {
  faCheck = faCheck;
  faTimes = faTimes;
  faUserPlus = faUserPlus;
  faCircleArrowLeft = faCircleArrowLeft;
  faTriangleExclamation = faTriangleExclamation;
  listTerritory: Observable<TerritoryModel[]>;
  territoryList: TerritoryModel[] = [];
  selecteduser: string;
  status: boolean = null;
  userList: UserWOCountModel[];
  confirmRecall: boolean = false;
  showDispatchPopup: boolean = false;
  userFilteredOut: boolean = false;
  disableSave: WritableSignal<boolean> = signal(false);
  public validationGroups = signal<DispatchValidationHitGroupModel[]>([]);
  public totalBlocked = signal<number>(0);
  public showValidationWarning = false;
  public showOverride = false;
  public overrideText = '';
  @Output() onRecallOrDispatchDone: EventEmitter<WorkOrderBase[]> =
    new EventEmitter<WorkOrderBase[]>();

  selectedWOstatus = input<string[]>([]);
  active = input<ViewResponseModel>(null);
  buttonsEnableState = computed<{
    enableDispatch: boolean;
    enableRecall: boolean;
  }>(() => {
    const selectedWOstatus = this.selectedWOstatus();
    return DispatchRecallComponent.enableRecallDispatch(selectedWOstatus);
  });

  constructor(
    public _clientWO: WorkorderGRPCService,
    private _clientWOActions: WorkOrderActionsGRPCService
  ) {
    super();
  }

  ngOnInit() {
    this.disableSave.set(false);
  }

  getFsrWoCount(list: TerritoryUser[]) {
    this.disableSave.set(false);
    this.gridData = undefined;
    //this removes duplicate users from teams
    var uniq = {};
    var filteredUserList = list.filter(
      (obj) => !uniq[obj.getUserName()] && (uniq[obj.getUserName()] = true)
    );

    var wos = this._clientWO.RXselectedWOIDsShared.getValue();
    var fsrcountmodel: FSRWOCountRequestModel = new FSRWOCountRequestModel();
    fsrcountmodel.contractID = this.active().contractName;
    fsrcountmodel.FSRList = TerritoryModel.userlist(filteredUserList);
    fsrcountmodel.activeOnly = true;

    this._clientWOActions.getFSRWOCount(fsrcountmodel).subscribe((response) => {  
      list.forEach((user: any) => {
        user.tmpCount = 0;
        response
          .filter((userR) => user.getName() == userR.name)
          .forEach((userRF) => (user.tmpCount += userRF.count));
      });

      this.userList = list.map((u: any) => {
        return {
          name: u.getName(),
          userName: u.getUserName(),
          count: u.tmpCount,
          skills: u.getSkillsList(),
        };
      });

      var userCount = this.userList.length;

      if (wos[0].ContractUseCertification) {
        uniq = {};
        var meterTypes = wos
          .map((x) => x.MeterType)
          .filter((obj) => !uniq[obj] && (uniq[obj] = true));

        //filter out tech without good skills
        this.userList = this.userList.filter((x) =>
          meterTypes.every(
            (mt) =>
              x.skills.findIndex(
                (s) => mt?.toLocaleLowerCase() == s?.toLocaleLowerCase()
              ) > -1
          )
        );
        this.userFilteredOut = userCount != this.userList.length;
      } else {
        this.userFilteredOut = false;
      }

      this.onStateChange(this.gridStateGB);
      this.loadingData = false;
    });
  }

  showDispatch() {
    this.gridData = [];
    this.selectionOnGrid = [];
    this.listTerritory = this._clientWOActions
      .getTerritory(this.active().contractName)
      .pipe(shareReplay());
    this.selecteduser = '';
    this.loadingData = true;
    this.getAllTerritoriesUsersList();
  }

  getAllTerritoriesUsersList() {
    this.listTerritory
      .pipe(
        map((x) => {
          this.territoryList = x;
          let u:TerritoryUser[] = [];
          this.territoryList.forEach((ter) => {
            ter.usersList.forEach((user) => {
               // Only add if not already present (by unique id or userId field)
              if (!u.some(existing => existing.getUserName() === user.getUserName())) {
                u.push(user);
              }
            });
          });
          this.getFsrWoCount(u);
        })
      )
      .subscribe();
  }

  territoryValueChange(e) {
    this.selectionOnGrid = [];
    this.selecteduser = '';

    if (e) {
      const territoryselected = this.territoryList.find(
        (item) => item.id === e
      );
      this.getFsrWoCount(territoryselected.usersList);
    } else {
      if (!this.loadingData) {
        //remove filter and load all user in grid
        this.getAllTerritoriesUsersList();
      }
    }
  }

  // One endpoint. The first attempt IS the validation check - if the server refuses, it dispatches
  // nothing and hands back the reasons.
  public onSave() {
    this.executeDispatch(false);
  }

  public onValidationProceed() {
    this.showValidationWarning = false;
    this.overrideText = '';
    this.showOverride = true;
  }

  public onValidationCancel() {          // AC 2 - back to WOED
    this.showValidationWarning = false;
  }

  public onOverrideCancel() {            // AC 4
    this.showOverride = false;
  }

  public onOverrideConfirm() {
    this.showOverride = false;
    this.executeDispatch(true);
  }

  private executeDispatch(overrideValidation: boolean) {
    if (this.selectionOnGrid.length > 0) {
      this.disableSave.set(true);
      var dispatchrequestmodel: DispatchRequestModel =
        new DispatchRequestModel();
      dispatchrequestmodel.techList = [];

      this.selectionOnGrid.forEach((uwo) => {
        var tech = new TechModel();
        tech.fsrName = uwo.name;
        tech.assignedto = uwo.userName;
        dispatchrequestmodel.techList.push(tech);
      });

      dispatchrequestmodel.wOList =
        this._clientWO.RXselectedWOIDsShared.getValue();

      dispatchrequestmodel.overrideValidation = overrideValidation;

      this._clientWOActions.dispatch(dispatchrequestmodel).subscribe({
        next: (x) => {
          const groups = x.getValidationGroupsList().map(DispatchValidationHitGroupModel.Mapper);
          if (groups.length > 0) {
            // Refused. Nothing was dispatched - do NOT run updateStatusAndEmit or close the panel.
            this.validationGroups.set(groups);
            this.totalBlocked.set(x.getTotalBlockedWorkOrders());
            this.showValidationWarning = true;
            this.disableSave.set(false);
            return;
          }
          const subscription = timer(500).subscribe(() => {
            this.showDispatchPopup = false;
            this.disableSave.set(false);
            this.updateStatusAndEmit(x);
            subscription.unsubscribe();
          });
        },
        error: (err) => {
          this.disableSave.set(false);
          console.error('Dispatch failed', err);
        },
      });
    }
  }

  public onRecallConfirm() {
    const selectedWOlist = this._clientWO.RXselectedWOIDsShared.getValue().map(
      (x) => x.name
    );
    this.disableSave.set(true);
    this._clientWOActions.recall(selectedWOlist).subscribe({
      next: (x) => {
        const subscription = timer(500).subscribe(() => {
          this.confirmRecall = false;
          this.disableSave.set(false);
          this.updateStatusAndEmit(x);
          subscription.unsubscribe();
        });
      },
      error: (err) => {
        this.disableSave.set(false);
        console.error('Recall failed', err);
      },
    });
  }

  private updateStatusAndEmit(x: any) {
    this.status = x.getWorkflowExceptionsList().length > 0 ? false : true;
    const WOSuccessBase: WorkOrderBase[] = x
      .getSuccessWorkOrdersList()
      .map((wo) => this.mapSuccessWorkOrdersList(wo));
    const WOFailedBase: WorkOrderBase[] = x
      .getFailedWorkOrdersList()
      .map((wo) => this.mapSuccessWorkOrdersList(wo));
    const WOBase: WorkOrderBase[] = [...WOSuccessBase, ...WOFailedBase];

    this.onRecallOrDispatchDone.emit(WOBase);
  }

  private mapSuccessWorkOrdersList(wo) {
    var ret = {
      name: wo.getWorkOrderName(),
      FsrIdentifier: null,
      AssignedTo: null,
      StatusWeb: wo.getStatusWeb(),
      ServiceType: null,
      Audited: null,
      AuditorName: null,
    };

    var teamAssignTo = wo.getTeamAssignTo();

    if (teamAssignTo != null && teamAssignTo != '') {
      ret.AssignedTo = teamAssignTo;
    } else {
      var tech = wo.getTechsList()[0];
      ret.FsrIdentifier = tech != null ? tech.getFsrName() : '';
      ret.AssignedTo = tech != null ? tech.getAssignTo() : '';
    }

    return ret;
  }

  public selectedCallback = (args) => args.dataItem;

  public selectionChange(event) {
    const r = super.selectionChange(event);
    this.selecteduser = this.selectionOnGrid.map((x) => x.userName).join(', ');
    return r;
  }

  /* #region manage grid state*/
  public override onStateChange(state: State) {
    super.onStateChange(state, this.userList);
    this.gridData = filterBy(this.userList, state.filter);
  }

  //to enable or disable Recall, Dispatch buttons based on Webstatus
  static enableRecallDispatch(selectedWOStatus: string[]) {
    var enableButtons = { enableDispatch: false, enableRecall: false };
    if (selectedWOStatus.length) {
      enableButtons.enableDispatch = selectedWOStatus.every(
        (x) =>
          x == WOStatusWeb.ReadyForDispatch || x == WOStatusWeb.ReadyForAudit
      );
      enableButtons.enableRecall = selectedWOStatus.every(
        (x) =>
          x == WOStatusWeb.Dispatched ||
          x == WOStatusWeb.Downloaded ||
          x == WOStatusWeb.Started
      );
    }
    return enableButtons;
  }
}
